<template>
  <!-- 课消统计柱状图 -->
  <div class="CourseStatistics">
    <div style="height: 30px;"><span @click="goBack" class="el-icon-circle-close"
        style="float: right; font-size: 24px;"></span></div>
    <div style="text-align: left;margin-left: 130px;"> <el-date-picker v-model="year" value-format="yyyy" type="year"
        placeholder="选择年" @change="seleYear">
      </el-date-picker></div>
    <div id="sumFeeYear" style="width: 100%; height: 400px;"></div>
    <div id="sumNumYear" style="width: 100%; height: 400px;"></div>
    <div id="meanFeeYear" style="width: 100%; height: 400px;"></div>
    <div id="bottom" style="width: 100%; height: 400px;"></div>
    <div id="center" style="width: 100%; height: 400px;"></div>
    <div id="top" style="width: 100%; height: 400px;"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import axios from "axios";
import apiBaseUrl from "../../../config/api";
import { h } from 'vue';
export default {
  data () {
    const stashStr = localStorage.getItem('stash')
    const stash = stashStr ? JSON.parse(stashStr) : {}
    return Object.assign({
      ownerDate: '',
      ownerDate1: '',
      meanFeeYears: [],
      sumFeeYears: [],
      sumNumYears: [],
      topArr: [],
      centerArr: [],
      bottomArr: [],
      text: '',
      year: ''
    }, stash)
  },
  created () {
    this.getTime()
    if (this.$route.query.time.length > 0) {
      this.ownerDate = this.$route.query.time
      this.text = this.$route.query.time.slice(0, 4)
      this.year = this.$route.query.time.slice(0, 4)
    } else {
      this.ownerDate = this.ownerDate1
      this.text = this.ownerDate1.slice(0, 4)
      this.year = this.ownerDate1.slice(0, 4)
      // console.log(this.ownerDate1.slice(0, 4));
    }
  },
  mounted () {
    this.getList()
    // this.ownerDate = this.$route.params.time
  },
  methods: {
    //根据年获取数据
    seleYear () {
      axios
        .get(`${apiBaseUrl}/classSales/getHistogramYear?year=${this.year}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {
          this.text = this.year
          this.meanFeeYears = res.data.data.data.classMeanFeeYear
          this.sumFeeYears = res.data.data.data.classSumFeeYear
          this.sumNumYears = res.data.data.data.classSumNumYear
          this.meanFeeYear()
          this.sumFeeYear()
          this.sumNumYear()
        })
        .catch(error => {
          console.error(error);
        });

    },
    getTime () {
      // 获取当前时间
      const today = new Date();
      // 获取当前时间(today)的年份
      const year = today.getFullYear();
      // 获取月份
      const month = String(today.getMonth() + 1).padStart(2, '0');
      this.ownerDate1 = `${year}-${month}`; //当前日期
    },
    getList () {
      axios
        .get(`${apiBaseUrl}/classSales/getHistogram?ownerDate=${this.ownerDate}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {
          this.topArr = res.data.data.data.classMeanFee//平均课时费
          this.centerArr = res.data.data.data.classSumNum//总课时数
          this.bottomArr = res.data.data.data.classSumFee//月总课消
          this.meanFeeYears = res.data.data.data.classMeanFeeYear
          this.sumFeeYears = res.data.data.data.classSumFeeYear
          this.sumNumYears = res.data.data.data.classSumNumYear

          this.line()

          this.lineCenter()
          this.lineBottom()
          this.meanFeeYear()
          this.sumFeeYear()
          this.sumNumYear()
        })
        .catch(error => {
          console.error(error);
        });

    },
    //关闭按钮
    goBack () {
      history.go(-1)
    },
    line () {
      let chartDom = document.getElementById('top');
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        color: ['#3f95c2'],
        tooltip: {
          trigger: 'axis'
        },
        dataZoom: [{
          type: 'slider',
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0]
        }],
        title: {
          text: this.ownerDate + '月平均课时费(每个教师 教师月课消÷教师月总课时数)',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this.topArr.map(item => item.nameOrMonth)
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.topArr.map(item => item.num),
            type: 'bar'
          }
        ]
      };

      option && myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      }
      myChart.setOption(option);
      myChart.off('click'); //防止触发两次点击事件
      myChart.getZr().on('click', (params) => {
        localStorage.setItem('stash', JSON.stringify(this.$data))
        let pointInPixel = [params.offsetX, params.offsetY];
        if (myChart.containPixel('grid', pointInPixel)) {
          let pointInGrid = myChart.convertFromPixel({
            seriesIndex: 0
          }, pointInPixel);
          let xIndex = pointInGrid[0]; //索引
          let handleIndex = Number(xIndex);
          // let seriesObj = myChart.getOption(); //图表object对象
          // var op = myChart.getOption();
          //获得图表中点击的列
          // var month = op.xAxis[0].data[handleIndex];  //获取点击的列名
          // console.log(month);
          // console.log(handleIndex);
          // console.log(this.topArr[handleIndex].curve);
          // const data=this.topArr[handleIndex]
          localStorage.setItem('dataObj', JSON.stringify(this.topArr[handleIndex]))
          this.$router.push({
            path: '/LineChart',
            // params:{data:JSON.stringify(this.topArr[handleIndex].curve)
            // }
          })
        };
      });
    },
    meanFeeYear () {
      let chartDom = document.getElementById('meanFeeYear');
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        color: ['skyblue'],
        tooltip: {
          trigger: 'axis'
        },
        title: {
          text: this.text + `年平均课时费(${this.text}年每个教师月课消÷教师月总课时数 相加)`,
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this.meanFeeYears.map(item => item.nameOrMonth)
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.meanFeeYears.map(item => item.num),
            type: 'bar'
          }
        ]
      };

      option && myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      }
    },

    sumFeeYear () {
      let chartDom = document.getElementById('sumFeeYear');
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        color: ['#ee6666'],
        tooltip: {
          trigger: 'axis'
        },
        title: {
          text: this.text + `年总课消(${this.text}年每个教师 月总课时数×签约的钱 相加)`,
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this.sumFeeYears.map(item => item.nameOrMonth)
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.sumFeeYears.map(item => item.num),
            type: 'bar'
          }
        ]
      };

      option && myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      }
      myChart.setOption(option);
      myChart.off('click'); //防止触发两次点击事件
      myChart.getZr().on('click', (params) => {
        localStorage.setItem('stash', JSON.stringify(this.$data))
        let pointInPixel = [params.offsetX, params.offsetY];
        if (myChart.containPixel('grid', pointInPixel)) {
          let pointInGrid = myChart.convertFromPixel({
            seriesIndex: 0
          }, pointInPixel);
          let xIndex = pointInGrid[0]; //索引
          let handleIndex = Number(xIndex);
          // console.log(handleIndex,'q');
          // console.log(this.sumFeeYears[handleIndex], '5');
          // console.log(this.text + '-' + (handleIndex + 1));
          // let seriesObj = myChart.getOption(); //图表object对象
          // var op = myChart.getOption();
          //获得图表中点击的列
          // var month = op.xAxis[0].data[handleIndex];  //获取点击的列名
          // console.log(month);
          // console.log(handleIndex);
          // console.log(this.topArr[handleIndex].curve);
          // const data=this.topArr[handleIndex]
          const timeText = this.text + '-' + (handleIndex + 1)
          // console.log(timeText);
          let dataObj = {
            timeText: timeText,
            data: this.sumFeeYears[handleIndex].curve.classSumFeeMonthDay
          }
          localStorage.setItem('dataObj', JSON.stringify(this.centerArr[handleIndex]))
          localStorage.setItem('dataStr', JSON.stringify(dataObj))
          this.$router.push({
            path: '/MonthOverallNum',
            // params: {
            //   timeText: timeText,
            //   data: this.sumFeeYears[handleIndex].curve.classSumFeeMonthDay
            // }
          })
        };
      });
    },
    sumNumYear () {
      let chartDom = document.getElementById('sumNumYear');
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        color: ['#5470c6'],
        tooltip: {
          trigger: 'axis'
        },
        title: {
          text: this.text + `年总课时数(${this.text}年每个教师月结课的课时总和 相加)`,
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this.sumNumYears.map(item => item.nameOrMonth)
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.sumNumYears.map(item => item.num),
            type: 'bar'
          }
        ]
      };

      option && myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      }
    },


    lineCenter () {
      let chartDom = document.getElementById('center');
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        color: ['#f39423'],
        dataZoom: [{
          type: 'slider',
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0]
        }],
        tooltip: {
          trigger: 'axis'
        },
        title: {
          text: this.ownerDate + '月总课时数(每个教师 月结课的课时总和)',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this.centerArr.map(item => item.nameOrMonth)
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.centerArr.map(item => item.num),
            type: 'bar'
          }
        ]
      };

      option && myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      }
      myChart.setOption(option);
      myChart.off('click'); //防止触发两次点击事件
      myChart.getZr().on('click', (params) => {
        localStorage.setItem('stash', JSON.stringify(this.$data))
        let pointInPixel = [params.offsetX, params.offsetY];
        if (myChart.containPixel('grid', pointInPixel)) {
          let pointInGrid = myChart.convertFromPixel({
            seriesIndex: 0
          }, pointInPixel);
          let xIndex = pointInGrid[0]; //索引
          let handleIndex = Number(xIndex);
          // let seriesObj = myChart.getOption(); //图表object对象
          // var op = myChart.getOption();
          //获得图表中点击的列
          // var month = op.xAxis[0].data[handleIndex];  //获取点击的列名
          // console.log(month);
          // console.log(handleIndex);
          // console.log(this.topArr[handleIndex].curve);
          // const data=this.topArr[handleIndex]
          localStorage.setItem('dataObj', JSON.stringify(this.centerArr[handleIndex]))
          this.$router.push({
            path: '/LineChart',
            // params:{data:JSON.stringify(this.topArr[handleIndex].curve)
            // }
          })
        };
      });
    },
    lineBottom () {
      let chartDom = document.getElementById('bottom');
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        color: ['#5087ec'],
        dataZoom: [{
          type: 'slider',
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0]
        }],
        tooltip: {
          trigger: 'axis'
        },
        title: {
          text: this.ownerDate + '月总课消(每个教师 月总课时数×签约的钱)',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this.bottomArr.map(item => item.nameOrMonth)
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.bottomArr.map(item => item.num),
            type: 'bar'
          }
        ]
      };

      option && myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      }
      myChart.setOption(option);
      myChart.off('click'); //防止触发两次点击事件
      myChart.getZr().on('click', (params) => {
        localStorage.setItem('stash', JSON.stringify(this.$data))
        let pointInPixel = [params.offsetX, params.offsetY];
        if (myChart.containPixel('grid', pointInPixel)) {
          let pointInGrid = myChart.convertFromPixel({
            seriesIndex: 0
          }, pointInPixel);
          let xIndex = pointInGrid[0]; //索引
          let handleIndex = Number(xIndex);
          // let seriesObj = myChart.getOption(); //图表object对象
          // var op = myChart.getOption();
          //获得图表中点击的列
          // var month = op.xAxis[0].data[handleIndex];  //获取点击的列名
          // console.log(month);
          // console.log(handleIndex);
          // console.log(this.topArr[handleIndex].curve);
          // const data=this.topArr[handleIndex]
          localStorage.setItem('dataObj', JSON.stringify(this.bottomArr[handleIndex]))
          this.$router.push({
            path: '/LineChart',
            // params:{data:JSON.stringify(this.topArr[handleIndex].curve)
            // }
          })
        };
      });
    }
  },
  watch: {
  },
  components: {

  },
}
</script>

<style scoped>
#itemchart {
  height: 400px;
}

@media screen and (max-width: 750px) {
  .CourseStatistics {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.CourseStatistics {
    width: 70% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/manager/components/CourseStatistics.vue